import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyHistory = createAsyncThunk('/dashboard_detail_company_history/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyClientDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyHistorySlice = createSlice({
    name: 'dashboard_detail_company_history',
    initialState: {
        isLoading: false,
        dashboard_detail_company_history: []
    },

    /*extraReducers: {
        [getDetailCompanyHistory.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyHistory.fulfilled]: (state, action) => {
            state.dashboard_detail_company_history = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyHistory.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyHistory.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyHistory.fulfilled, (state, action) => {
                state.dashboard_detail_company_history = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyHistory.rejected, (state) => {
                state.isLoading = false;
            });
    }   
})

export default dashboardDetailCompanyHistorySlice.reducer